import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';

export const ErrorPage = observer<PropsWithChildren>(({ children }) => {
	return <h1>{children}</h1>;
});
